// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload button {
  margin-left: 5px;
}

.section-title {
  margin-bottom: 50px;
}

.file-input-btn {
  margin-bottom: 0;
}

.upload .previews {
  margin: 0 10px;
}

.upload .localsubmit {
  margin: 0 10px;
}

.example-headers-align .mat-expansion-panel-header-title,
.example-headers-align .mat-expansion-panel-header-description {
  flex-basis: 0;
}

.example-headers-align .mat-expansion-panel-header-description {
  justify-content: space-between;
  align-items: center;
}

mat-form-field {
  margin-right: 12px;
}

.btn {
  margin-right: 8px;
}

.mat-action-row {
  border-top-style: none;
  padding: 4px 4px 4px 4px;
}

.rt-full-width {
  width: 70%;
}

ol {
  columns: 1;
  -webkit-columns: 1;
  -moz-columns: 1;
}

li {
  margin-top: 5px;
  margin-left: 10px;
  padding: 2px;
}

.fileupload-drop-zone {
  border: 1px solid green;
  height: 50px;
}

.divLabel {
  float: left;
  border-radius: 10%;
  height: 32px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/doc-upload/doc-upload.component.scss","webpack://./../../audit%20module/RedThread/src/app/pages/doc-upload/doc-upload.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;ACAJ;;ADGA;EACE,mBAAA;ACAF;;ADGA;EACE,gBAAA;ACAF;;ADIE;EACE,cAAA;ACDJ;;ADME;EACE,cAAA;ACHJ;;ADOA;;EAEE,aAAA;ACJF;;ADOA;EACE,8BAAA;EACA,mBAAA;ACJF;;ADOA;EACE,kBAAA;ACJF;;ADOA;EACE,iBAAA;ACJF;;ADMA;EACE,sBAAA;EACA,wBAAA;ACHF;;ADKA;EACE,UAAA;ACFF;;ADIA;EACE,UAAA;EACA,kBAAA;EACA,eAAA;ACDF;;ADGA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;ACAF;;ADEA;EACE,uBAAA;EACA,YAAA;ACCF;;ADCA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;ACEF","sourcesContent":[".upload {\r\n  button {\r\n    margin-left: 5px;\r\n  }\r\n}\r\n.section-title {\r\n  margin-bottom: 50px\r\n}\r\n\r\n.file-input-btn {\r\n  margin-bottom: 0\r\n}\r\n\r\n.upload {\r\n  .previews {\r\n    margin: 0 10px\r\n  }\r\n}\r\n\r\n.upload {\r\n  .localsubmit {\r\n    margin: 0 10px\r\n  }\r\n}\r\n\r\n.example-headers-align .mat-expansion-panel-header-title,\r\n.example-headers-align .mat-expansion-panel-header-description {\r\n  flex-basis: 0;\r\n}\r\n\r\n.example-headers-align .mat-expansion-panel-header-description {\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\nmat-form-field {\r\n  margin-right: 12px;\r\n}\r\n\r\n.btn {\r\n  margin-right: 8px;\r\n}\r\n.mat-action-row {\r\n  border-top-style:none;\r\n  padding: 4px 4px 4px 4px;\r\n}\r\n.rt-full-width {\r\n  width: 70%;\r\n}\r\nol {\r\n  columns: 1;\r\n  -webkit-columns: 1;\r\n  -moz-columns: 1;\r\n}\r\nli{\r\n  margin-top: 5px;\r\n  margin-left: 10px;\r\n  padding: 2px;\r\n}\r\n.fileupload-drop-zone{\r\n  border: 1px solid green;\r\n  height: 50px;\r\n}\r\n.divLabel{\r\n  float: left;\r\n  border-radius: 10%;\r\n  height: 32px;\r\n  color: white;\r\n}\r\n",".upload button {\n  margin-left: 5px;\n}\n\n.section-title {\n  margin-bottom: 50px;\n}\n\n.file-input-btn {\n  margin-bottom: 0;\n}\n\n.upload .previews {\n  margin: 0 10px;\n}\n\n.upload .localsubmit {\n  margin: 0 10px;\n}\n\n.example-headers-align .mat-expansion-panel-header-title,\n.example-headers-align .mat-expansion-panel-header-description {\n  flex-basis: 0;\n}\n\n.example-headers-align .mat-expansion-panel-header-description {\n  justify-content: space-between;\n  align-items: center;\n}\n\nmat-form-field {\n  margin-right: 12px;\n}\n\n.btn {\n  margin-right: 8px;\n}\n\n.mat-action-row {\n  border-top-style: none;\n  padding: 4px 4px 4px 4px;\n}\n\n.rt-full-width {\n  width: 70%;\n}\n\nol {\n  columns: 1;\n  -webkit-columns: 1;\n  -moz-columns: 1;\n}\n\nli {\n  margin-top: 5px;\n  margin-left: 10px;\n  padding: 2px;\n}\n\n.fileupload-drop-zone {\n  border: 1px solid green;\n  height: 50px;\n}\n\n.divLabel {\n  float: left;\n  border-radius: 10%;\n  height: 32px;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
